import MenuItemTags from './MenuItemTags'

export default MenuItemTags
